import React from 'react'

import { EmptyConnectionCardHeader } from './EmptyConnectionCardHeader'

import { emptyConnection } from './EmptyConnection.css'

interface EmptyConnectionCardProps {
  children?: React.ReactNode
}

export const EmptyConnectionCard: React.FC<EmptyConnectionCardProps> = ({
  children,
}) => {
  return (
    <div className={emptyConnection}>
      <EmptyConnectionCardHeader />
      <div className="p-24">{children}</div>
    </div>
  )
}
